import { Container, DialogActions, DialogContent } from '@mui/material';
import styles from './sales-force-failed-orders.module.scss';
import { Col, Row } from 'reactstrap';
import { Box, Button, CreateHeaders, dateAndTimeHeader, dateHeader, Dialog, DialogTitle, HeaderSizeEnum, OrderTypesEnum, SuccessButton, TextField, textHeader } from '@frontend-workspace/react-shared-lib';
import PageTitle from '../page-title/page-title';
import WebkuaTable from '../webkua-table/webkua-table';
import { makeRequest, useGetRequestNewHook } from '../requestUtils';
import { ValueFormatterParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { UseSignalRHook } from '../signalr-context/signalr-context';
import { getSalesforceFollowUpLabel } from '../order-state-label';

/* eslint-disable-next-line */
export interface SalesForceFailedOrdersProps { }

export function SalesForceFailedOrders(props: SalesForceFailedOrdersProps) {
  const { data, getData } = useGetRequestNewHook('salesforce/orders', []);
  const { t } = useTranslation();


  UseSignalRHook(getData, [OrderTypesEnum.SFChangeAssetOrder, OrderTypesEnum.SFUpdateContractOrder, OrderTypesEnum.SFCreateCompanyOrder, OrderTypesEnum.SFUpdateCompanyOrder, OrderTypesEnum.SFAddSupportHoursOrder]);
  const [isLoading, setLoading] = useState(false);
  const [isCreateAccountOpen, setCreateAccountOpen] = useState(false);
  const handleRetryRenderer = (params: ValueFormatterParams) => {
    return <Button onClick={() => handleRetryOrder(params.value, params.data.orderType)} variant="contained" color="primary" disabled={isLoading}>
      Retry
    </Button>
  }


  const handleRetryOrder = (id: string, type: string) => {
    setLoading(true);
    makeRequest(`admin/action/manuallyRunOrder/`, "PUT", {
      orderId: id,
      orderType: type,
    }).then(() => {
      setLoading(false);
      getData();
    });
  }
  const handleSetAsManuallyHandled = (id: string) => {
    setLoading(true);
    makeRequest(`orders/${id}/action/setToManuallyHandled`, 'PUT').then(() => {
      setLoading(false);
      getData();
    });
  }
  const handleSetAsManuallyHandledRenderer = (params: ValueFormatterParams) => {
    return <Button onClick={() => handleSetAsManuallyHandled(params.value)} variant="contained" color="primary" disabled={isLoading}>
      Set as handled
    </Button>
  }
  return (
    <>
      <Container
        className="container-fluid pt-4 px-0"
        maxWidth={false}>
        <Row>
          <Col>
            <Box>
              <PageTitle title={t("supportOrders.followUpTitle")} subtitle='' />
              <SuccessButton
                variant="contained"
                onClick={() => setCreateAccountOpen(true)}
                disabled={isLoading}
              >
                Create Account
              </SuccessButton>
              <WebkuaTable
                onRefresh={getData}
                headers={CreateHeaders([
                  textHeader("orderId", t("standard.id")),
                  textHeader("orderType", t("standard.orderType")),
                  textHeader("state", t("standard.state"), HeaderSizeEnum.MEDIUM, { renderer: params => getSalesforceFollowUpLabel(params.data, t) }),
                  dateAndTimeHeader("activationDate", t("standard.activationDate")),
                  textHeader("companyNumber", t("standard.companyNumber")),
                  textHeader("contractNumber", t("standard.contractNumber")),
                  textHeader("errorMessage", t("standard.errorMessage")),
                  textHeader("orderId", "", HeaderSizeEnum.SMALL, { renderer: handleRetryRenderer }),
                  textHeader("orderId", "", HeaderSizeEnum.SMALL, { renderer: handleSetAsManuallyHandledRenderer }),
                ])}
                data={data}
              />
            </Box>
          </Col>
        </Row>
      </Container>
      {isCreateAccountOpen && <CreateAccountDialog onClose={() => setCreateAccountOpen(false)} />}
    </>
  );

}
function CreateAccountDialog({ onClose }: { onClose: () => void }) {
  const [companyNumber, setCompanyNumber] = useState('');
  const [changedByEmail, setChangedByEmail] = useState('');
  const [salesRepEmail, setSalesRepEmail] = useState('');
  const [orgNr, setOrgNr] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [autodeskCompanyNumber, setAutodeskCompanyNumber] = useState('');
  const [visitingCity, setVisitingCity] = useState('');
  return (
    <Dialog open maxWidth="md" onClose={onClose}>
      <DialogTitle>
        Manually create account
      </DialogTitle>
      <DialogContent>


        <TextField
          label="Company Number"
          value={companyNumber}
          onChange={(e) => setCompanyNumber(e.target.value)}
          fullWidth />
        <TextField
          label="Sales Rep Email"
          value={salesRepEmail}
          onChange={(e) => setSalesRepEmail(e.target.value)}
          fullWidth />
        <TextField

          label="Org Nr"
          value={orgNr}
          onChange={(e) => setOrgNr(e.target.value)}
          fullWidth />
        <TextField

          label="Company Name"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          fullWidth />
        <TextField
          label="Autodesk Company Number"
          value={autodeskCompanyNumber}
          onChange={(e) => setAutodeskCompanyNumber(e.target.value)}
          fullWidth />
        <TextField
          label="Visiting City"
          value={visitingCity}
          onChange={(e) => setVisitingCity(e.target.value)}
          fullWidth />
        <TextField
          label="Changed By Email"
          value={changedByEmail}
          onChange={(e) => setChangedByEmail(e.target.value)}
          fullWidth />


      </DialogContent>
      <DialogActions>
        <SuccessButton
          variant="contained"
          onClick={() => {
            makeRequest('salesforce/account', 'POST', {
              companyNumber,
              salesRepEmail,
              orgNr,
              companyName,
              autodeskCompanyNumber,
              visitingCity,
              changedByEmail
            }).then(() => {
              if (onClose) onClose();
            });
          }}
        >
          Create Account
        </SuccessButton>
        <Button
          variant="outlined"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>

    </Dialog>
  );
}

export default SalesForceFailedOrders;
